module.exports = __webpack_public_path__ + "static/media/report-icon.f2c81241.svg";